<app-content-header [contentHeader]="contentHeader"></app-content-header>

<!-- Tabs Navigation -->
<nav class="nav nav-tabs" style="background-color: rgb(255, 255, 255); padding: 20px!important; border: 1px solid #1d243a18;">
    <a class="nav-link" [ngClass]="{'active': activeTab === 'lista'}" (click)="setActiveTab('lista')">
        Rastreadores
    </a>
    <a class="nav-link" [ngClass]="{'active': activeTab === 'lote'}" (click)="setActiveTab('lote')">
        Lote de Entrada
    </a>
</nav>

<div *ngIf="activeTab === 'lista'">
    <!-- <div class="d-flex justify-content-end mb-2">
        <button class="btn btn-primary" (click)="onCreate()">
            <i data-feather="plus" class="mr-1"></i>
            Lote de Entrada
        </button>
    </div> -->

    <!-- Add a clear filters button -->
    <div class="d-flex justify-content-start mb-1">
        <button class="btn btn-secondary" (click)="clearFilters()">
            Redefinir Filtros
        </button>
    </div>

    <ngx-datatable 
        class="material core-bootstrap" 
        [rowHeight]="58" 
        [limit]="basicSelectedOption" 
        columnMode="force"
        [reorderable]="false" 
        [swapColumns]="false" 
        [footerHeight]="50" 
        [headerHeight]="120"
        [loadingIndicator]="loading" 
        style="box-shadow: none" 
        [rows]="rows" 
        [scrollbarH]="false"
        [count]="totalItems"
        [offset]="currentPage - 1"
        [limit]="itemsPerPage"
        [externalPaging]="true"
        (page)="onPageChange($event)">

        <ng-template ngx-datatable-loading-template>
            <div class="text-center">
                <div class="spinner-border text-primary" role="status">
                    <span class="sr-only">Carregando...</span>
                </div>
            </div>
        </ng-template>

        <ngx-datatable-column name="IMEI" prop="imei" [sortable]="false">
            <ng-template let-column="column" ngx-datatable-header-template>
                <h4>IMEI</h4>
                <div class="input-group">
                    <input type="search" placeholder="Pesquisar IMEI" class="form-control"
                        [(ngModel)]="searchParams.imei" (keyup)="imeiFilter($event)" />
                    <div class="input-group-append" *ngIf="searchParams.imei">
                        <button class="btn btn-outline-secondary" type="button" (click)="searchParams.imei = ''; searchSubject.next()">
                            <i class="fas fa-times"></i>
                        </button>
                    </div>
                </div>
            </ng-template>
            <ng-template ngx-datatable-cell-template let-row="row">
                <span class="font-weight-bold">{{ row.imei || '-' }}</span>
            </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="Modelo" prop="modelo_rastreador" [sortable]="false">
            <ng-template let-column="column" ngx-datatable-header-template>
                <h4>Modelo</h4>
                <input type="search" placeholder="Pesquisar Modelo" class="ml-25 form-control"
                    (keyup)="modeloFilter($event)" />
            </ng-template>
            <ng-template ngx-datatable-cell-template let-row="row">
                <span class="font-weight-bold">{{ row.modelo_rastreador || '-' }}</span>
            </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="Estoque" prop="estoque" [sortable]="false">
            <ng-template let-column="column" ngx-datatable-header-template>
                <h4>Estoque</h4>
                <input type="search" placeholder="Pesquisar Estoque" class="ml-25 form-control"
                    (keyup)="estoqueFilter($event)" />
            </ng-template>
            <ng-template ngx-datatable-cell-template let-row="row">
                <span class="badge badge-pill badge-light-secondary">
                    {{ row.estoque || '0' }}
                </span>
            </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="Status" prop="flg_status" [sortable]="false">
            <ng-template let-column="column" ngx-datatable-header-template>
                <h4>Status</h4>
                <select [(ngModel)]="selectedStatus" (change)="statusFilter()"
                    class="ml-25 form-control" name="" id="">
                    <option [value]="0">Todos</option>
                    <option [value]="1">No Estoque</option>
                    <option [value]="2">Vendido</option>
                </select>
            </ng-template>
            <ng-template ngx-datatable-cell-template let-row="row">
                <span class="badge badge-pill" 
                    [ngClass]="{
                        'badge-light-success': row.flg_status == '1',
                        'badge-light-danger': row.flg_status == '2'
                    }">
                    {{row.flg_status == '1' ? 'No Estoque' : 'Vendido'}}
                </span>
            </ng-template>
        </ngx-datatable-column>

        <!-- Coluna de Ações -->
        <!-- <ngx-datatable-column name="Ações" prop="acao" [width]="100" [sortable]="false">
            <ng-template ngx-datatable-cell-template let-row="row">
                <button class="btn btn-primary btn-sm btn-circle mr-1" title="editar" (click)="onEdit(row.id_rastreador)">
                    <i data-feather="edit"></i>
                </button>
                <button class="btn btn-danger btn-sm btn-circle" title="excluir" (click)="onDelete(row.id_rastreador)">
                    <i data-feather="trash-2"></i>
                </button>
            </ng-template>
        </ngx-datatable-column> -->
    </ngx-datatable>
</div>

<!-- Content for Lote de Entrada -->
<div *ngIf="activeTab === 'lote'">
    <div class="d-flex justify-content-between mb-2">
        <button class="btn btn-secondary" (click)="clearFilters()">
            Redefinir Filtros
        </button>
        <button class="btn btn-primary" [routerLink]="['/rastreador-entrada/cadastro']">
            <i data-feather="plus" class="mr-1"></i>
            Novo Lote
        </button>
    </div>

    <div *ngIf="loading">
        <p>Carregando dados...</p>
    </div>

    <div *ngIf="!loading && lotes.length === 0">
        <p>Nenhum lote encontrado.</p>
    </div>

    <ngx-datatable 
        *ngIf="!loading && lotes.length > 0"
        class="material core-bootstrap" 
        [rowHeight]="58" 
        [limit]="basicSelectedOption" 
        columnMode="force"
        [reorderable]="false" 
        [swapColumns]="false" 
        [footerHeight]="50" 
        [headerHeight]="50"
        [loadingIndicator]="loading" 
        style="box-shadow: none" 
        [rows]="lotes" 
        [scrollbarH]="false"
        [externalPaging]="false"
        [count]="lotes.length"
        [offset]="0">

        <ngx-datatable-column name="Data Compra" prop="dt_compra" [sortable]="false">
            <ng-template let-column="column" ngx-datatable-header-template>
                <h4>Data Compra</h4>
            </ng-template>
            <ng-template ngx-datatable-cell-template let-row="row">
                <span class="font-weight-bold">{{ row.dt_compra | date:'dd/MM/yyyy' || '-' }}</span>
            </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="Data Chegada" prop="dt_chegada" [sortable]="false">
            <ng-template let-column="column" ngx-datatable-header-template>
                <h4>Data Chegada</h4>
            </ng-template>
            <ng-template ngx-datatable-cell-template let-row="row">
                <span class="font-weight-bold">{{ row.dt_chegada | date:'dd/MM/yyyy' || '-' }}</span>
            </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="Modelo" prop="modelo_rastreador" [sortable]="false">
            <ng-template let-column="column" ngx-datatable-header-template>
                <h4>Modelo</h4>
            </ng-template>
            <ng-template ngx-datatable-cell-template let-row="row">
                <span class="font-weight-bold">{{ row.modelo_rastreador || '-' }}</span>
            </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="Despachante" prop="nome_despachante" [sortable]="false">
            <ng-template let-column="column" ngx-datatable-header-template>
                <h4>Despachante</h4>
            </ng-template>
            <ng-template ngx-datatable-cell-template let-row="row">
                <span class="font-weight-bold">{{ row.nome_despachante || '-' }}</span>
            </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="Fábrica" prop="nome_fabricante" [sortable]="false">
            <ng-template let-column="column" ngx-datatable-header-template>
                <h4>Fábrica</h4>
            </ng-template>
            <ng-template ngx-datatable-cell-template let-row="row">
                <span class="font-weight-bold">{{ row.nome_fabricante || '-' }}</span>
            </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="Fornecedor" prop="nome_fornecedor" [sortable]="false">
            <ng-template let-column="column" ngx-datatable-header-template>
                <h4>Fornecedor</h4>
            </ng-template>
            <ng-template ngx-datatable-cell-template let-row="row">
                <span class="font-weight-bold">{{ row.nome_fornecedor || '-' }}</span>
            </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="Qtd. Rastreadores" prop="total_rastreadores" [sortable]="false">
            <ng-template let-column="column" ngx-datatable-header-template>
                <h4>Qtd. Rastreadores</h4>
            </ng-template>
            <ng-template ngx-datatable-cell-template let-row="row">
                <span class="font-weight-bold">{{ row.total_rastreadores || '0' }}</span>
            </ng-template>
        </ngx-datatable-column>

        <!-- Coluna de Ações -->
        <ngx-datatable-column name="Ações" prop="acao" [width]="100" [sortable]="false">
            <ng-template ngx-datatable-cell-template let-row="row">
                <button class="btn btn-info btn-sm btn-circle" title="Visualizar" [routerLink]="['/rastreador-entrada/visualizar', row.id_rastreador_lote_entrada]">
                    <i data-feather="eye"></i>
                </button>
            </ng-template>
        </ngx-datatable-column>
    </ngx-datatable>
</div>
